import CreateIcon from '@mui/icons-material/AddCircleOutline';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import React, { useState } from 'react';
import { IProject } from '@Data/projects/Interfaces';
import DeleteProjectDialogue from '../ManageProject/DeleteProjectDialog';
import { ManageProjectType } from '../ManageProject/ManageProjectDialog';
import Styles from './ProjectsList.scss';
import ProjectsListRow from './ProjectsListRow';
import ProjectsListSkeleton from './ProjectsListSkeleton';

interface IProjectsListProps {
    isLoading: boolean;
    onClick: (project: IProject) => void;
    onEdit: (project: IProject, manageProjectType: ManageProjectType) => void;
    onDelete: (project: IProject, callback?: () => void) => void;
    projects: Array<IProject>;
    onCreateProject: () => void;
}

const ProjectsList = (props: IProjectsListProps) => {
    const { isLoading, onClick, onEdit, onDelete, projects, onCreateProject } =
        props;

    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] =
        useState<boolean>(false);
    const [projToDelete, setProjToDelete] = useState<IProject>(null);

    const handleDelete = (event, project: IProject) => {
        event.stopPropagation();
        setProjToDelete(project);
        setIsConfirmDeleteOpen(true);
    };

    const handleCloseDeleteDialogue = () => {
        setIsConfirmDeleteOpen(false);
        setProjToDelete(null);
    };

    const confirmDelete = () => {
        setIsDeleting(true);
        onDelete(projToDelete, () => {
            handleCloseDeleteDialogue();
            setIsDeleting(false);
        });
    };

    let tableRows: Array<any>;

    if (isLoading) {
        tableRows = [
            <ProjectsListSkeleton key="plSkeleton1" />,
            <ProjectsListSkeleton key="plSkeleton2" />,
        ];
    } else {
        const trStyle = { cursor: 'pointer' };
        tableRows = [];
        tableRows.push(
            <TableRow onClick={onCreateProject} style={trStyle} key="createTr">
                <TableCell>
                    <div className={Styles.plCreateContainer}>
                        <CreateIcon />
                        <span className={Styles.plName}>
                            Create New Project
                        </span>
                    </div>
                </TableCell>
            </TableRow>
        );

        tableRows.push(
            ...projects.map((p: IProject) => {
                return (
                    <ProjectsListRow
                        onClick={onClick}
                        onEditProjectName={() =>
                            onEdit(p, ManageProjectType.EDIT_NAME)
                        }
                        onDelete={handleDelete}
                        project={p}
                        trStyle={trStyle}
                        key={`plrow-${p.project_id}`}
                    />
                );
            })
        );
    }

    return (
        <React.Fragment>
            <Table size="small" style={{ width: '50vw' }}>
                <TableBody>{tableRows}</TableBody>
            </Table>
            <DeleteProjectDialogue
                isOpen={isConfirmDeleteOpen}
                onClose={handleCloseDeleteDialogue}
                isDeleting={isDeleting}
                onDelete={confirmDelete}
                projectName={projToDelete ? projToDelete.project_name : ''}
            />
        </React.Fragment>
    );
};

export default ProjectsList;
